<template>
  <div class="content">
      <div  v-html="content" class="term_content"></div>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
export default {
  data () {
    return {
      content: '',
      termList: [],
      term: [],
      params: this.$route.params
    }
  },
  methods: {
    getContent () {
      let data = {fair_id: this.params.id, termid: this.params.termid}
      axios
        .post('/cat/search-ticket', data)
        .then(this.getContentSucc)
    },
    getContentSucc (res) {
      res = res.data
      if (res.status && res.data) {
        this.content = res.data[0].content
      }
    },
    HistoryBack () {
      window.history.back()
    }
  },
  mounted () {
    this.getContent()
  }
}
</script>

<style lang="stylus" scoped>
  .content
    min-height: 8rem
    background-color: rgba(255,255,255,0.15)
    padding: .2rem .26rem .4rem .26rem
    border-radius: .2rem
    font-size: .26rem
    line-height: 1.5
  .term_content
    min-height: 8rem
    background-color: rgba(255,255,255,0.15)
    padding: .4rem .26rem
    border-radius: .2rem
    font-size: .26rem
    line-height: 1.5
</style>



// WEBPACK FOOTER //
// src/views/template1/TermContent.vue